import { Breadcrumbs, Typography } from "@mui/material";
import Link from "next/link";

export const HUB_BREADCRUMBS = {
  hub: { label: "Horszone Hub", url: "/hub" },
  guides: { label: "Guides", url: "/hub/guides" },
};

export function HubBreadcrumbs({
  breadcrumbs,
}: {
  breadcrumbs: { label: string; url: string }[];
}) {
  return (
    <Breadcrumbs
      sx={(theme) => ({
        ...theme.typography.caption,
        padding: theme.spacing(0, 4),
        [theme.breakpoints.down("sm")]: {
          padding: theme.spacing(0, 2),
        },
      })}
    >
      <Link href="/">Home</Link>
      {breadcrumbs.slice(0, -1).map((breadcrumb) => (
        <Link key={breadcrumb.url} href={breadcrumb.url}>
          {breadcrumb.label}
        </Link>
      ))}
      <Typography aria-current="page" variant="caption">
        {breadcrumbs[breadcrumbs.length - 1].label}
      </Typography>
    </Breadcrumbs>
  );
}
